var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sheet" } }, [
    _c(
      "div",
      {
        attrs: { id: "sheet-disp-area" },
        on: {
          contextmenu: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              id: "sheet2",
              width: _vm.svgWidth,
              height: _vm.svgHeight,
              transform: "scale(1, -1)",
              viewBox: _vm.sheetViewBox,
              preserveAspectRatio: "xMinYMax meet"
            },
            on: {
              wheel: _vm.wheelOnSheet,
              mousemove: _vm.mousemoveOnSheet,
              mousedown: _vm.mousedownOnSheet,
              mouseup: _vm.mouseupOnSheet
            }
          },
          [
            _vm._l(_vm.sheetModel.combineBomList, function(bom, index) {
              return _c(
                "g",
                {
                  key: "combineBomList_" + index,
                  class: { sheet_info: true, sheet_info_imp: _vm.isShowInfo },
                  attrs: {
                    transform:
                      "translate(" +
                      bom.startX +
                      " " +
                      bom.startY +
                      ") scale(1, -1)"
                  }
                },
                [
                  _c("text", { attrs: { x: "10", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.no))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "30", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.itemName))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "130", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.size))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "230", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.quantity))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "260", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.itemNumber))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "360", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.cabinetPattern))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "440", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.otherItemNumber))
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.sheetModel.partsBomList, function(bom, index) {
              return _c(
                "g",
                {
                  key: "partsBomList_" + index,
                  attrs: {
                    transform:
                      "translate(" +
                      bom.startX +
                      " " +
                      bom.startY +
                      ") scale(1, -1)"
                  }
                },
                [
                  _c("text", { attrs: { x: "10", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.no))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "30", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.partsName))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "130", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.itemNumber))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "230", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.size))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "330", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.quantity))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "360", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.figureNumber))
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.sheetModel.fittingBomList, function(bom, index) {
              return _c(
                "g",
                {
                  key: "fittingBomList_" + index,
                  attrs: {
                    transform:
                      "translate(" +
                      bom.startX +
                      " " +
                      bom.startY +
                      ") scale(1, -1)"
                  }
                },
                [
                  _c("text", { attrs: { x: "10", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.no))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "30", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.partsName))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "130", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.itemNumber))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "230", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.quantity))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "260", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.manufactureName))
                  ]),
                  _vm._v(" "),
                  _c("text", { attrs: { x: "360", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.figureNumber))
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.sheetModel.finishingMaterialList, function(bom, index) {
              return _c(
                "g",
                {
                  key: "finishingMaterialList_" + index,
                  attrs: {
                    transform:
                      "translate(" +
                      bom.startX +
                      " " +
                      bom.startY +
                      ") scale(1, -1)"
                  }
                },
                [
                  _c("text", { attrs: { x: "10", "font-size": bom.font } }, [
                    _vm._v(_vm._s(bom.finishingMaterial))
                  ])
                ]
              )
            }),
            _vm._v(" "),
            _vm._l(_vm.sheetModel.sheetGroupModelList, function(
              sheetGroup,
              index
            ) {
              return _c(
                "g",
                { key: "sheetGroup_" + index },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        transform:
                          "translate(" +
                          (_vm.sheetGroupLBX(sheetGroup) + 13) +
                          "," +
                          (_vm.sheetGroupLBY(sheetGroup) + 13) +
                          ")"
                      }
                    },
                    [
                      _c(
                        "text",
                        {
                          attrs: { "font-size": "20", transform: "scale(1,-1)" }
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(sheetGroup.sheetTitle) +
                              "\n            "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "g",
                    _vm._l(sheetGroup.linePartsModelList, function(
                      line,
                      index
                    ) {
                      return _c("line", {
                        key: "line_" + index,
                        attrs: {
                          x1:
                            _vm.sheetGroupX(sheetGroup) +
                            line.startX * _vm.sheetModel.scale,
                          y1:
                            _vm.sheetGroupY(sheetGroup) +
                            line.startY * _vm.sheetModel.scale,
                          x2:
                            _vm.sheetGroupX(sheetGroup) +
                            line.endX * _vm.sheetModel.scale,
                          y2:
                            _vm.sheetGroupY(sheetGroup) +
                            line.endY * _vm.sheetModel.scale,
                          z: line.z,
                          stroke: line.color ? line.color : "black",
                          "stroke-width":
                            (line.lineWeight ? line.lineWeight : 1) *
                              _vm.svgZoomRatio +
                            "px",
                          "stroke-dasharray": _vm.getDashArray(line)
                        }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _vm._l(sheetGroup.movableShelfPointList, function(ms, index) {
                    return _c(
                      "g",
                      {
                        key: "ms_" + index,
                        attrs: {
                          "stroke-width":
                            (ms.lineWeight ? ms.lineWeight : 1) *
                              _vm.svgZoomRatio +
                            "px",
                          fill: "none",
                          stroke: "black"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M " +
                              (_vm.sheetGroupX(sheetGroup) +
                                ms.x * _vm.sheetModel.scale) +
                              " " +
                              (_vm.sheetGroupY(sheetGroup) +
                                ms.y * _vm.sheetModel.scale) +
                              " v " +
                              30 * _vm.sheetModel.scale +
                              " l " +
                              10 * _vm.sheetModel.scale +
                              " " +
                              -20 * _vm.sheetModel.scale
                          }
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d:
                              "M " +
                              (_vm.sheetGroupX(sheetGroup) +
                                ms.x * _vm.sheetModel.scale) +
                              " " +
                              (_vm.sheetGroupY(sheetGroup) +
                                ms.y * _vm.sheetModel.scale) +
                              " v " +
                              -30 * _vm.sheetModel.scale +
                              " l " +
                              -10 * _vm.sheetModel.scale +
                              " " +
                              20 * _vm.sheetModel.scale
                          }
                        })
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._l(sheetGroup.grainLineList, function(grain, index) {
                    return _c(
                      "g",
                      {
                        key: "grain_" + index,
                        attrs: {
                          "stroke-width":
                            (grain.lineWeight ? grain.lineWeight : 1) *
                              _vm.svgZoomRatio +
                            "px",
                          fill: "none",
                          stroke: "black"
                        }
                      },
                      [
                        _c("line", {
                          attrs: {
                            x1:
                              _vm.sheetGroupX(sheetGroup) +
                              grain.startX * _vm.sheetModel.scale,
                            y1:
                              _vm.sheetGroupY(sheetGroup) +
                              grain.startY * _vm.sheetModel.scale,
                            x2:
                              _vm.sheetGroupX(sheetGroup) +
                              grain.endX * _vm.sheetModel.scale,
                            y2:
                              _vm.sheetGroupY(sheetGroup) +
                              grain.endY * _vm.sheetModel.scale,
                            z: "0",
                            stroke: grain.color ? grain.color : "black",
                            "stroke-width":
                              (grain.lineWeight ? grain.lineWeight : 1) *
                                _vm.svgZoomRatio +
                              "px",
                            "stroke-dasharray": _vm.getDashArray(grain)
                          }
                        }),
                        _vm._v(" "),
                        grain.startArrow
                          ? _c("path", {
                              attrs: {
                                d:
                                  "M " +
                                  (_vm.sheetGroupX(sheetGroup) +
                                    (grain.startX + grain.arrowX) *
                                      _vm.sheetModel.scale) +
                                  " " +
                                  (_vm.sheetGroupY(sheetGroup) +
                                    (grain.startY + grain.arrowY) *
                                      _vm.sheetModel.scale) +
                                  " l " +
                                  -grain.arrowX * _vm.sheetModel.scale +
                                  " " +
                                  -grain.arrowY * _vm.sheetModel.scale +
                                  " l " +
                                  grain.arrowX * _vm.sheetModel.scale +
                                  " " +
                                  -grain.arrowY * _vm.sheetModel.scale,
                                transform:
                                  "rotate(" +
                                  grain.angle +
                                  ", " +
                                  (_vm.sheetGroupX(sheetGroup) +
                                    grain.startX * _vm.sheetModel.scale) +
                                  ", " +
                                  (_vm.sheetGroupY(sheetGroup) +
                                    grain.startY * _vm.sheetModel.scale) +
                                  ")"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        grain.endArrow
                          ? _c("path", {
                              attrs: {
                                d:
                                  "M " +
                                  (_vm.sheetGroupX(sheetGroup) +
                                    (grain.endX - grain.arrowX) *
                                      _vm.sheetModel.scale) +
                                  " " +
                                  (_vm.sheetGroupY(sheetGroup) +
                                    (grain.endY + grain.arrowY) *
                                      _vm.sheetModel.scale) +
                                  " l " +
                                  grain.arrowX * _vm.sheetModel.scale +
                                  " " +
                                  -grain.arrowY * _vm.sheetModel.scale +
                                  " l " +
                                  -grain.arrowX * _vm.sheetModel.scale +
                                  " " +
                                  -grain.arrowY * _vm.sheetModel.scale,
                                transform:
                                  "rotate(" +
                                  grain.angle +
                                  ", " +
                                  (_vm.sheetGroupX(sheetGroup) +
                                    grain.endX * _vm.sheetModel.scale) +
                                  ", " +
                                  (_vm.sheetGroupY(sheetGroup) +
                                    grain.endY * _vm.sheetModel.scale) +
                                  ")"
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    _vm._l(sheetGroup.circlePartsModelList, function(
                      circle,
                      index
                    ) {
                      return _c("circle", {
                        key: "circle_" + index,
                        attrs: {
                          cx:
                            _vm.sheetGroupX(sheetGroup) +
                            circle.x * _vm.sheetModel.scale,
                          cy:
                            _vm.sheetGroupY(sheetGroup) +
                            circle.y * _vm.sheetModel.scale,
                          r: circle.r * _vm.sheetModel.scale,
                          stroke: circle.color ? circle.color : "black",
                          fill: "none",
                          "stroke-width":
                            (circle.lineWeight ? circle.lineWeight : 1) *
                              _vm.svgZoomRatio +
                            "px",
                          "stroke-dasharray": _vm.getDashArray(circle)
                        }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "g",
                    _vm._l(sheetGroup.arcPartsModelList, function(arc, index) {
                      return _c("path", {
                        key: "arc_" + index,
                        attrs: {
                          d: _vm.buildPathData(sheetGroup, arc),
                          stroke: arc.color ? arc.color : "black",
                          fill: "none",
                          "stroke-width":
                            (arc.lineWeight ? arc.lineWeight : 1) *
                              _vm.svgZoomRatio +
                            "px",
                          "stroke-dasharray": _vm.getDashArray(arc)
                        }
                      })
                    })
                  ),
                  _vm._v(" "),
                  _vm._l(sheetGroup.textPartsModelList, function(text, index) {
                    return _c(
                      "g",
                      {
                        key: "text_" + index,
                        attrs: {
                          transform:
                            "translate(" +
                            text.x * _vm.sheetModel.scale +
                            " " +
                            text.y * _vm.sheetModel.scale +
                            ") scale(1, -1)"
                        }
                      },
                      [
                        _c(
                          "text",
                          {
                            attrs: {
                              transform: "rotate(-" + text.angle + ")",
                              "text-anchor": "middle",
                              "font-size": text.font ? text.font : "12"
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(text.text) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    [
                      _vm._l(sheetGroup.dimensionPartsModelList, function(
                        dim,
                        index
                      ) {
                        return _c("line", {
                          key: "dim_" + index,
                          attrs: {
                            x1:
                              _vm.sheetGroupX(sheetGroup) +
                              dim.startX * _vm.sheetModel.scale,
                            y1:
                              _vm.sheetGroupY(sheetGroup) +
                              dim.startY * _vm.sheetModel.scale,
                            x2:
                              _vm.sheetGroupX(sheetGroup) +
                              dim.endX * _vm.sheetModel.scale,
                            y2:
                              _vm.sheetGroupY(sheetGroup) +
                              dim.endY * _vm.sheetModel.scale,
                            stroke: dim.lineColor ? dim.lineColor : "black",
                            "stroke-width":
                              (dim.lineWeight ? dim.lineWeight : 1) *
                                _vm.svgZoomRatio +
                              "px"
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(sheetGroup.dimensionPartsModelList, function(
                        dimPoint,
                        index
                      ) {
                        return _c("circle", {
                          key: "dimPoint_" + index,
                          attrs: {
                            cx:
                              _vm.sheetGroupX(sheetGroup) +
                              dimPoint.startX * _vm.sheetModel.scale,
                            cy:
                              _vm.sheetGroupY(sheetGroup) +
                              dimPoint.startY * _vm.sheetModel.scale,
                            r: dimPoint.point * _vm.svgZoomRatio,
                            stroke: "black",
                            fill: "black",
                            "stroke-width": dimPoint.lineWeight
                              ? dimPoint.lineWeight
                              : "1px"
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(sheetGroup.dimensionPartsModelList, function(
                        dimText,
                        index
                      ) {
                        return dimText.text
                          ? _c(
                              "g",
                              {
                                key: "dimText" + index,
                                attrs: {
                                  transform:
                                    "translate(" +
                                    (_vm.sheetGroupX(sheetGroup) +
                                      (dimText.startX + dimText.endX) /
                                        (dimText.horizontaInside ? 4 : 2) *
                                        _vm.sheetModel.scale) +
                                    " " +
                                    (_vm.sheetGroupY(sheetGroup) +
                                      (dimText.startY + dimText.endY) /
                                        2 *
                                        _vm.sheetModel.scale) +
                                    ") " +
                                    "scale(1, -1)"
                                }
                              },
                              [
                                _c(
                                  "text",
                                  {
                                    attrs: {
                                      transform:
                                        "translate(" +
                                        dimText.hposition +
                                        "," +
                                        dimText.vposition +
                                        ") " +
                                        "rotate(-" +
                                        (dimText.textAngle
                                          ? dimText.textAngle
                                          : 0) +
                                        ")",
                                      "text-anchor": "middle",
                                      "font-size": dimText.textSize
                                        ? dimText.textSize
                                        : "7",
                                      fill: dimText.textColor
                                        ? dimText.textColor
                                        : "black"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(dimText.text) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "g",
                    _vm._l(sheetGroup.originMarkerList, function(
                      origin,
                      index
                    ) {
                      return _c("g", { key: "origin_" + index }, [
                        _c("line", {
                          attrs: {
                            x1:
                              _vm.sheetGroupX(sheetGroup) +
                              origin.x * _vm.sheetModel.scale,
                            y1:
                              _vm.sheetGroupY(sheetGroup) +
                              origin.y * _vm.sheetModel.scale,
                            x2:
                              _vm.sheetGroupX(sheetGroup) +
                              origin.vertex1.x * _vm.sheetModel.scale,
                            y2:
                              _vm.sheetGroupY(sheetGroup) +
                              origin.vertex1.y * _vm.sheetModel.scale,
                            stroke: "black",
                            "stroke-width": _vm.svgZoomRatio + "px"
                          }
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            x1:
                              _vm.sheetGroupX(sheetGroup) +
                              origin.x * _vm.sheetModel.scale,
                            y1:
                              _vm.sheetGroupY(sheetGroup) +
                              origin.y * _vm.sheetModel.scale,
                            x2:
                              _vm.sheetGroupX(sheetGroup) +
                              origin.vertex2.x * _vm.sheetModel.scale,
                            y2:
                              _vm.sheetGroupY(sheetGroup) +
                              origin.vertex2.y * _vm.sheetModel.scale,
                            stroke: "black",
                            "stroke-width": _vm.svgZoomRatio + "px"
                          }
                        }),
                        _vm._v(" "),
                        _c("line", {
                          attrs: {
                            x1:
                              _vm.sheetGroupX(sheetGroup) +
                              origin.vertex1.x * _vm.sheetModel.scale,
                            y1:
                              _vm.sheetGroupY(sheetGroup) +
                              origin.vertex1.y * _vm.sheetModel.scale,
                            x2:
                              _vm.sheetGroupX(sheetGroup) +
                              origin.vertex2.x * _vm.sheetModel.scale,
                            y2:
                              _vm.sheetGroupY(sheetGroup) +
                              origin.vertex2.y * _vm.sheetModel.scale,
                            stroke: "black",
                            "stroke-width": _vm.svgZoomRatio + "px"
                          }
                        })
                      ])
                    })
                  ),
                  _vm._v(" "),
                  _c(
                    "g",
                    [
                      _vm._l(sheetGroup.sectionPointPartsModelList, function(
                        sec,
                        index
                      ) {
                        return _c("line", {
                          key: "sec1_" + index,
                          attrs: {
                            x1:
                              _vm.sheetGroupX(sheetGroup) +
                              sec.x * _vm.sheetModel.scale,
                            y1:
                              _vm.sheetGroupY(sheetGroup) +
                              sec.y * _vm.sheetModel.scale,
                            x2:
                              _vm.sheetGroupX(sheetGroup) +
                              sec.x * _vm.sheetModel.scale +
                              sec.footX,
                            y2:
                              _vm.sheetGroupY(sheetGroup) +
                              sec.y * _vm.sheetModel.scale +
                              sec.footY,
                            stroke: sec.lineColor ? _vm.dim.lineColor : "black",
                            "stroke-width": 1 * _vm.svgZoomRatio + "px"
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(sheetGroup.sectionPointPartsModelList, function(
                        sec,
                        index
                      ) {
                        return _c("line", {
                          key: "sec2_" + index,
                          attrs: {
                            x1:
                              _vm.sheetGroupX(sheetGroup) +
                              sec.x * _vm.sheetModel.scale,
                            y1:
                              _vm.sheetGroupY(sheetGroup) +
                              sec.y * _vm.sheetModel.scale,
                            x2:
                              _vm.sheetGroupX(sheetGroup) +
                              sec.x * _vm.sheetModel.scale +
                              sec.lineX,
                            y2:
                              _vm.sheetGroupY(sheetGroup) +
                              sec.y * _vm.sheetModel.scale +
                              sec.lineY,
                            stroke: sec.lineColor ? _vm.dim.lineColor : "black",
                            "stroke-width": 1 * _vm.svgZoomRatio + "px"
                          }
                        })
                      }),
                      _vm._v(" "),
                      _vm._l(sheetGroup.sectionPointPartsModelList, function(
                        sec,
                        index
                      ) {
                        return _c(
                          "g",
                          {
                            key: "secLabel_" + index,
                            attrs: {
                              transform:
                                "translate(" +
                                (_vm.sheetGroupX(sheetGroup) +
                                  sec.x * _vm.sheetModel.scale) +
                                "," +
                                (_vm.sheetGroupY(sheetGroup) +
                                  sec.y * _vm.sheetModel.scale) +
                                ") " +
                                "scale(1, -1)"
                            }
                          },
                          [
                            _c(
                              "text",
                              {
                                attrs: {
                                  transform:
                                    "translate(" +
                                    sec.textXPos +
                                    "," +
                                    sec.textYPos +
                                    ")",
                                  "text-anchor": "middle",
                                  "font-size": "7",
                                  fill: "black"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(sec.label) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ],
                2
              )
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42d116e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d116e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/top/input/estimate/DcEstimateSheet.vue
// module id = null
// module chunks = 